import { render, staticRenderFns } from "./OrgOrder.vue?vue&type=template&id=78f4e279&scoped=true"
import script from "./OrgOrder.vue?vue&type=script&lang=js"
export * from "./OrgOrder.vue?vue&type=script&lang=js"
import style0 from "./OrgOrder.vue?vue&type=style&index=0&id=78f4e279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4e279",
  null
  
)

export default component.exports